import { render } from "./MenubarSub.vue?vue&type=template&id=52647fce"
import script from "./MenubarSub.vue?vue&type=script&lang=js"
export * from "./MenubarSub.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__